import React, { useState, useEffect, useMemo, Fragment } from 'react';
import { WritingModeProvider as NovaWritingModeProvider, useIsRTL } from '@sas/nova-commons/locale';
import { PopoverManagerProvider } from '@sas/nova-commons/components/Popover/PopoverManager';
import { loadLocalizers } from '../../locale/I18nLoader';
import { I18nProvider } from '../../locale/I18nContext';
import defaultLocalizers from '../../i18n_js/messages';
import messagesManifest from '../../i18n_js/messagesManifest';
import loadingTextBundle from '../../i18n_js/loadingTextBundle';
import defaultLoadingLocalizers from '../../i18n_js/loadingText';
import { getDefaultPopoverRoot, PopoverRootProvider as NovaPopoverRootProvider, } from '@sas/nova-commons/hooks/usePopoverRoot';
import { useLocale, useHonorLocalFormatSettings, useLocaleTextDir } from '../../config';
import { GlobalSettingsProvider } from '@sas/nova-commons/components/Settings';
import { globalSettingsDataProvider } from '../ReportContainer/internal/globalSettingsDataProvider';
import { GlobalSettingsThemeParametersProvider } from '@sas/nova-commons/theme';
export const CoreContextProviders = (props) => {
    return (React.createElement(WritingModeProvider, null,
        React.createElement(PopoverRootProvider, { popoverRootId: props.popoverRootId },
            React.createElement(LoadI18nProvider, null,
                React.createElement(PopoverManagerProvider, null,
                    React.createElement(MaybeGlobalSettingsProvider, null, props.children))))));
};
const MaybeGlobalSettingsProvider = (props) => {
    const enabled = useHonorLocalFormatSettings();
    return enabled ? (React.createElement(GlobalSettingsThemeParametersProvider, null,
        React.createElement(GlobalSettingsProvider, { dataProvider: globalSettingsDataProvider }, props.children))) : (React.createElement(Fragment, null, props.children));
};
const WritingModeProvider = (props) => {
    const direction = useLocaleTextDir();
    return React.createElement(NovaWritingModeProvider, { direction: direction }, props.children);
};
const LoadI18nProvider = (props) => {
    const [localizers, setLocalizers] = useState(defaultLocalizers);
    const [loadingTextLocalizers, setLoadingLocalizers] = useState(defaultLoadingLocalizers);
    const locale = useLocale();
    useEffect(() => {
        let ignoreResult = false;
        // FIXME: For consistancy with nova and portable we only need to pass in
        // one requested language. The underlying code should be change to accept
        // a string instead of an array.
        const requestedLanguages = [locale];
        loadLocalizers(messagesManifest, requestedLanguages).then((response) => {
            if (ignoreResult) {
                return;
            }
            setLocalizers(response);
        });
        setLoadingLocalizers(loadLocalizers(loadingTextBundle, requestedLanguages));
        return () => {
            ignoreResult = true;
        };
    }, [locale]);
    const value = useMemo(() => ({ localizers, loadingTextLocalizers }), [
        localizers,
        loadingTextLocalizers,
    ]);
    return React.createElement(I18nProvider, { value: value }, props.children);
};
const PopoverRootProvider = (props) => {
    const [popoverRoot, setPopoverRoot] = useState(null);
    const isRTL = useIsRTL();
    useEffect(() => {
        if (!props.popoverRootId) {
            setPopoverRoot(undefined);
            return;
        }
        const popoverRoot = document.getElementById(props.popoverRootId);
        if (!popoverRoot) {
            setPopoverRoot(undefined);
            return;
        }
        setPopoverRoot(popoverRoot);
    }, [props.popoverRootId]);
    useEffect(() => {
        if (popoverRoot === null) {
            return;
        }
        const currPopoverRoot = popoverRoot !== null && popoverRoot !== void 0 ? popoverRoot : getDefaultPopoverRoot(isRTL);
        currPopoverRoot.dir = isRTL ? 'rtl' : 'ltr';
    }, [isRTL, popoverRoot]);
    return React.createElement(NovaPopoverRootProvider, { value: popoverRoot }, props.children);
};
